import PropTypes from 'prop-types';
import React from 'react';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';
import Report from '../../../common/components/Report';
import ReportCustomFilterTypes from '../../../../common/redux/actions/types/ReportCustomFilterTypes';

const EdiExchangeReport = props => (
  <Report
    id={props.id}
    tabs={[
      {
        value: ReportDefinitions.EDI_EXCHANGE_LETTER_706.id,
        label: 'Letter',
      },
      {
        value: ReportDefinitions.EDI_EXCHANGE_PARCEL_706.id,
        label: 'Parcel',
      },
      {
        value: ReportDefinitions.EDI_EXCHANGE_EMS_706.id,
        label: 'EMS',
      },
    ]}
    className="no-stripe"
    customFilterType={ReportCustomFilterTypes.EDI_EXCHANGE_706}
    {...props}
  />
);
export default EdiExchangeReport;

EdiExchangeReport.propTypes = {
  id: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  generatedOnDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  reportId: PropTypes.string,
};
